import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { styles } from './styles.css';

export default class Footer extends Component {
  render() {
    return (
      <div className={classNames(styles, 'col-xs-12')}>
        <p>© 2018 <strong>daniel seripap</strong>. <a href="https://github.com/seripap" rel='noopener noreferrer'>github</a> | @<a href="https://twitter.com/gibberish" rel='noopener noreferrer'>gibberish</a></p>
        <p style={{ marginTop: "5px" }}>for press, <a className="special">ds[at]linux.com</a></p>
      </div>
    );
  }
}
